document.addEventListener("DOMContentLoaded", function () {

  const input = document.getElementById("engraving_input");
  if (!input) return;

  let currentMax = 3;

  const radios = document.querySelectorAll('input[type="radio"][name^="Number of Characters"]');

  function getMax(value) {
    if (value.includes("1-3")) return 3;
    if (value.includes("4-5")) return 5;
    if (value.includes("6-7")) return 7;
    return 3;
  }

  function updateUI(max) {
    currentMax = max;
    input.maxLength = max;
    input.value = "";
    input.placeholder = "Up to " + max + " characters";
  }

  // Initial load
  const checked = document.querySelector('input[type="radio"][name^="Number of Characters"]:checked');
  if (checked) {
    updateUI(getMax(checked.value));
  }

  // Variant change
  radios.forEach(radio => {
    radio.addEventListener("change", function () {
      if (this.checked) {
        updateUI(getMax(this.value));
      }
    });
  });

  // Input restriction
  input.addEventListener("input", function () {
    this.value = this.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
  });

});